/**
 * Used by the "shape" prop to render either a square or circle avatar.
 * @type {Object<String>}
 */
export const SHAPES = {
    SQUARE: 'square',
    CIRCLE: 'circle'
};

/**
 * Used by few "positions" props such as icon positions, online indicator positions etc.
 * @type {Object<String>}
 */
export const POSITIONS = {
    TOP_RIGHT: 'TOP_RIGHT',
    BOTTOM_RIGHT: 'BOTTOM_RIGHT',
    TOP_LEFT: 'TOP_LEFT',
    BOTTOM_LEFT: 'BOTTOM_LEFT'
};
